import { render } from "./AdminContactos.vue?vue&type=template&id=aabc91fc"
import script from "./AdminContactos.vue?vue&type=script&lang=js"
export * from "./AdminContactos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__